var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeckButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6795 20.0046L26.2445 27.5663C26.3774 27.6985 26.483 27.8558 26.555 28.029C26.627 28.2022 26.6641 28.3879 26.6641 28.5754C26.6641 28.763 26.627 28.9487 26.555 29.1219C26.483 29.2951 26.3774 29.4523 26.2445 29.5846C25.9747 29.8508 25.6109 30 25.232 30C24.853 30 24.4892 29.8508 24.2195 29.5846L15.6445 21.0163C15.385 20.7562 15.2359 20.4061 15.2281 20.0388C15.2203 19.6715 15.3545 19.3154 15.6028 19.0446L24.2128 10.4163C24.4807 10.1469 24.8446 9.99489 25.2245 9.9938C25.6044 9.9927 25.9692 10.1426 26.2386 10.4104C26.508 10.6783 26.66 11.0422 26.6611 11.4222C26.6622 11.8021 26.5123 12.1669 26.2445 12.4363L18.6795 20.0046Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeckButton);
export default __webpack_public_path__ + "static/media/beckButton.9562f3a86bfb9263e82e9c04008d6315.svg";
export { ForwardRef as ReactComponent };